import {
  getSubscriptions
} from "./chunk-P6JUTAOY.mjs";

// src/hooks/wbk/subscriptions/list.ts
import { useQuery } from "@tanstack/react-query";
var useGetSubscriptions = (props) => {
  return useQuery({
    queryKey: ["getSubscriptions", props],
    queryFn: () => getSubscriptions(props)
  });
};

export {
  useGetSubscriptions
};
//# sourceMappingURL=chunk-2GWVVAPC.mjs.map